import {
  Footer as StyledFooter,
  P,
  Title,
  Contents,
  Box,
} from "./Footer.styled";

export const Footer = () => {
  return (
    <Box className="footer">
      <StyledFooter>
        <Box sx={{ display: "flex" }}>
          <P>
            <Title>주식회사 GC메디아이</Title>
          </P>
        </Box>
        <Box>
          <P>
            <Title>대표자</Title>
            <Contents>김진태</Contents>
          </P>
        </Box>
        <Box>
          <P>
            <Title>주소</Title>
            <Contents>
              04765 서울특별시 성동구 왕십리로 241, LF층 (행당동, 서울숲더샵)
            </Contents>
          </P>
        </Box>
        <Box sx={{ display: "flex" }}>
          <P>
            <Title>사업자등록번호</Title>
            <Contents>201-81-55688</Contents>
          </P>
        </Box>
        <P>
          <Title>통신판매업신고번호</Title>
          <Contents>구로 제02282호</Contents>
        </P>
      </StyledFooter>
      <Box
        sx={{
          color: "#A1B1CA",
        }}
      >
        COPYRIGHT ©GC MediAI Corporation. All rights reserved.
      </Box>
    </Box>
  );
};

export default Footer;
